export default {
	er_cover_default_title: 'مراجعة الأداء',
	er_page_success_metrics: 'ما الذي تغيّر هذا الشهر',
	er_page_success_metrics_range: 'ما الذي تغيّر في هذه الفترة',
	er_page_success_metrics_week: 'ما الذي تغيّر هذا الأسبوع',
	er_page_comparison: 'ملخص المقارنة',
	er_page_period_summary: 'ملخص الشهر',
	er_page_period_summary_range: 'ملخص الفترة',
	er_page_period_summary_week: 'ملخص الأسبوع',
	er_page_each_month: 'كل شهر',
	er_page_rooms: 'الغرف',
	er_rooms_note: 'كل غرفة في {month}، الأعلى تقييمًا أولاً.',
	er_page_shift_comparison: 'مقارنة حسب الوردية',
	er_page_shift_summary: 'حسب الوردية',
	er_page_response_time: 'متوسط زمن الاستجابة (دقائق)',
	er_page_avg_score: 'درجة التجربة',
	er_page_complaints_vs_visits: 'الشكاوى مقارنة بالزيارات',
	er_page_performance_trends: 'اتجاهات الأداء',
	er_page_complaint_drivers: 'مسببات الشكاوى',

	er_board_working: 'تحسّن مقارنة بـ {month}',
	er_board_attention: 'يحتاج انتباهاً مقارنة بـ {month}',
	er_board_empty: 'لا توجد تغيّرات بارزة هذا الشهر.',
	er_board_empty_range: 'لا توجد تغيّرات بارزة في هذه الفترة.',
	er_board_empty_week: 'لا توجد تغيّرات بارزة هذا الأسبوع.',
	er_findings_intro: 'مقارنةً بـ {month}. تُعرض التغييرات البارزة فقط.',
	er_verdict_improved: 'تحسّن',
	er_verdict_watch: 'يحتاج انتباهاً',

	er_col_metric: 'المؤشر',
	er_col_avg: 'متوسط العام',
	er_col_lifetime_avg: 'متوسط منذ البداية',
	er_comparison_note: 'متوسط العام هو الرقم من يناير حتى {month}.',
	er_lifetime_note: 'متوسط منذ البداية هو المتوسط الشهري من أول يوم فيه بيانات حتى {month}.',
	er_comparison_note_week: 'يُقارن أسبوع التقرير بالأسبوع السابق المحدد.',
	er_period_only_note: 'الأرقام تخص {month} فقط.',
	er_each_month_note: 'كل شهر في الفترة المحددة. الشهر الذي لا يحتوي على بيانات يبقى فارغاً.',
	er_col_inc_dec: 'التغير',
	er_col_complaint: 'الشكوى',
	er_col_qty: 'العدد',
	er_total: 'الإجمالي',

	er_metric_avg_score: 'درجة التجربة',
	er_metric_avg_response_time: 'متوسط زمن الاستجابة',
	er_metric_cleaner_arrivals: 'وصول عمال النظافة',
	er_metric_supervisor_inspections: 'جولات المشرفين',
	er_metric_complaints_vs_visits_pct: 'الشكاوى مقابل الزيارات (%)',
	er_metric_complaints: 'الشكاوى',
	er_metric_customer_visits: 'الزيارات',
	er_metric_expired_slas: 'اتفاقيات الخدمة المنتهية',
	er_unit_min: 'دقيقة',
	er_stat_expected_sla: 'اتفاقية الخدمة المتوقعة',
	er_stat_vs_minutes: 'مقارنة بـ {value} في {month}',
	er_stat_vs_count: 'مقارنة بـ {value} في {month}',
	er_label_complaints: 'الشكاوى',
	er_label_visits: 'الزيارات',
	er_label_complaints_per_visits: 'الشكاوى / الزيارات',
	er_cv_formula: 'الشكاوى مقسومة على زيارات دورات المياه كنسبة مئوية: ({complaints} ÷ {visits}) × 100 = {ratio}% في {month}.',
	er_export_kpis_title: 'ما الذي يتضمنه التقرير',
	er_export_kpis_desc: 'كل هذه المؤشرات مدرجة في التقرير. أوقف مؤشراً لاستبعاده.',
	er_export_select_all: 'تحديد الكل',
	er_export_clear_all: 'مسح الكل',
	er_export_summary: '{report} مقابل {compare}',
	er_export_period_title: 'فترة التقرير',
	er_export_grain: 'التقرير حسب',
	er_export_grain_month: 'شهر',
	er_export_grain_week: 'أسبوع',
	er_export_week_starts: 'يبدأ الأسبوع يوم',
	er_export_week_starts_sunday: 'الأحد',
	er_export_week_starts_monday: 'الاثنين',
	er_export_report_month: 'شهر التقرير',
	er_export_from_month: 'من شهر',
	er_export_to_month: 'إلى شهر',
	er_export_period_note_range: 'يجمع التقرير كل شهر من البداية حتى النهاية. عند تفعيل المقارنة تُستخدم الفترة السابقة بنفس الطول. أرقام السنة حتى تاريخه تبقى من يناير حتى شهر النهاية.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} مقابل {compare}',
	er_export_compare_range_note: 'الفترة السابقة بنفس الطول.',
	er_export_report_week: 'أسبوع التقرير',
	er_export_compare_month: 'المقارنة مع',
	er_export_shift: 'الوردية',
	er_export_shift_all: 'كل الورديات',
	er_export_no_shifts: 'لا توجد ورديات نشطة في هذا الموقع.',
	er_export_render_failed: 'تعذّر عرض التقرير بشكل صحيح، لذلك لم يتم تنزيله. حدّث الصفحة وحاول مرة أخرى.',
	er_export_comparison: 'المقارنة',
	er_export_include_previous: 'تضمين الفترة السابقة',
	er_export_comparison_on: 'تشغيل',
	er_export_comparison_off: 'إيقاف',
	er_export_no_previous_data: 'لا توجد بيانات قبل هذه الفترة، لذلك لا يوجد ما تُقارن به.',
	er_export_compare_previous: 'الشهر السابق',
	er_export_compare_previous_week: 'الأسبوع السابق',
	er_export_compare_last_year: 'نفس الشهر في العام الماضي',
	er_export_no_periods: 'يحتاج هذا الموقع إلى شهر واحد على الأقل من البيانات لتصدير تقرير.',
	er_export_no_periods_week: 'يحتاج هذا الموقع إلى أسبوع واحد على الأقل من البيانات لتصدير تقرير.',
	er_export_period_note: 'تُعرض الأشهر التي تحتوي على بيانات فقط. أرقام العام حتى تاريخه تمتد دائماً من يناير حتى شهر التقرير.',
	er_export_period_note_week: 'تُعرض الأسابيع التي تحتوي على بيانات فقط. المقارنة دائماً مع أسبوع سابق.',
	er_export_period_note_single_week: 'تُعرض الأسابيع التي تحتوي على بيانات فقط.',
	er_chart_ratio: 'نسبة الشكاوى إلى الزيارات',
	er_chart_ytd_window: 'من يناير حتى {month}.',

	er_find_response_time_title: 'متوسط زمن الاستجابة',
	er_find_response_time_change: 'تغيّر من {previous} إلى {current} دقيقة ({change}).',
	er_find_avg_score_title: 'درجة التجربة',
	er_find_score_eased: 'انخفض من {previous} إلى {current}.',
	er_find_score_improved: 'ارتفع من {previous} إلى {current}.',
	er_find_score_ytd_inline: 'يطابق متوسط العام حتى اليوم {ytd}.',
	er_find_score_ytd_inline_range: 'يطابق المتوسط من يناير حتى {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'متوسط العام حتى اليوم: {ytd}.',
	er_find_score_ytd_against_range: 'المتوسط من يناير حتى {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'نسبة الشكاوى إلى الزيارات',
	er_find_complaints_ratio_improved: 'تحسّن من {previous} إلى {current}.',
	er_find_complaints_ratio_rose: 'تغيّر من {previous} إلى {current}.',

	er_nar_cv_year_improved: 'تحسّنت شكاوى العملاء مقارنة بزيارات دورات المياه من {from} إلى {to} خلال العام.',
	er_nar_cv_year_rose: 'ارتفعت شكاوى العملاء مقارنة بزيارات دورات المياه من {from} إلى {to} خلال العام.',
	er_nar_cv_moved: 'تغيّرت شكاوى العملاء مقارنة بزيارات دورات المياه من {previous} إلى {current}.',
	er_nar_cv_current: 'تبلغ شكاوى العملاء مقارنة بزيارات دورات المياه {current}.',
	er_nar_types_total: 'إجمالي الشكاوى {total}.',
	er_nar_types_1: 'الشكوى الأبرز: {a} ({ap}%).',
	er_nar_types_2: 'الشكوى الأبرز: {a} ({ap}%) تليها {b} ({bp}%).',
	er_nar_types_3: 'الشكوى الأبرز: {a} ({ap}%) تليها {b} ({bp}%) ثم {c} ({cp}%).',
	er_find_rooms_slowest: 'الغرف ذات أطول وقت استجابة هذا الشهر: {rooms}.',
	er_find_rooms_slowest_range: 'الغرف ذات أطول وقت استجابة في هذه الفترة: {rooms}.',
	er_find_rooms_slowest_week: 'الغرف ذات أطول وقت استجابة هذا الأسبوع: {rooms}.',
	er_find_rooms_lowest_score: 'الغرف الأقل تقييماً هذا الشهر: {rooms}.',
	er_find_rooms_lowest_score_range: 'الغرف ذات أدنى تقييم في هذه الفترة: {rooms}.',
	er_find_rooms_lowest_score_week: 'الغرف الأقل تقييماً هذا الأسبوع: {rooms}.',

	er_find_so_what_ratio: 'جاء معظم التغيير من {rooms}.',
	er_find_so_what_type: 'أعلى شكوى: {name} ({percent}%).',
	er_hot_slowest: 'الغرف ذات أطول وقت استجابة',
	er_hot_expired_slas: 'الغرف التي تجاوزت اتفاقية الخدمة',
	er_hot_ratio: 'الغرف ذات أكبر تغيّر في معدل الشكاوى',
	er_hot_top_type: 'الغرف ذات أكبر عدد من شكاوى "{name}"',
	er_hot_col_room: 'غرفة',
	er_col_response: 'الاستجابة',
	er_col_cleaners: 'عمال النظافة',
	er_col_score: 'التقييم',
	er_chart_sla: 'اتفاقية مستوى الخدمة',
	er_hot_col_ratio: 'النسبة',
	er_hot_col_change: 'التغيير',
	er_hot_col_count: 'العدد',
	er_hot_empty: 'لا توجد نقاط بارزة على مستوى الغرف هذا الشهر.',
	er_hot_empty_range: 'لا توجد نقاط بارزة على مستوى الغرف في هذه الفترة.',
	er_hot_empty_week: 'لا توجد نقاط بارزة على مستوى الغرف هذا الأسبوع.',
	er_cover_highlights: 'هذا الشهر',
	er_cover_highlights_range: 'هذه الفترة',
	er_cover_highlights_week: 'هذا الأسبوع',
	er_cover_score_rose: 'ارتفعت درجة التجربة.',
	er_cover_score_eased: 'انخفضت درجة التجربة.',
	er_cover_response_improved: 'تحسّن وقت الاستجابة.',
	er_cover_response_slowed: 'تباطأ وقت الاستجابة.',
	er_cover_ratio_fell: 'انخفضت نسبة الشكاوى إلى الزيارات.',
	er_cover_ratio_rose: 'ارتفعت نسبة الشكاوى إلى الزيارات.',
	er_export_pdf: 'PDF للوحة',
	er_export_executive: 'التقرير التنفيذي',
	'executive-report': 'التقرير التنفيذي',
	er_export_csv: 'CSV',
	er_export_status_title: 'جارٍ إنشاء التقرير',
	er_export_status_fetch: 'جارٍ تحميل الأرقام',
	er_export_status_layout: 'جارٍ ترتيب الصفحات',
	er_export_status_page: 'الصفحة {page} من {total}',
	er_footer_copyright: 'تم إنشاء هذا التقرير عبر نظام BuzzzTech.',
	er_contact_line: 'هل لديك أسئلة أو ترغب في استكشاف البيانات بمزيد من التفصيل؟ تواصل مع فريق نجاح العملاء في BuzzzTech عبر {email} أو {phone}.',
};
